module.exports = __webpack_public_path__ + "img/website-service-10.c971a8d5.png";